// Read-only menu shown to ROLE_ANALYTIC users.
// Grants view-only access to Dashboard, Admin (clients), Savdo nuqtalari (poses) and Qarzdorlik (debtor).
export let exportAnalyticMenu = [
    {
        url: "/dashboard",
        i18n: "HOME",
        icon: "uil-home-alt",
        active: false,
    },
    {
        url: "/admin/clients",
        i18n: "ADMIN",
        icon: "uil-users-alt",
        active: false,
    },
    {
        url: "/pos",
        i18n: "POSES",
        icon: "uil-shop",
        active: false,
    },
    {
        url: "/admin/debt/excel",
        i18n: "DEBTOR",
        icon: "uil-file-alt",
        active: false,
    },
]
